import './VenueClubDetailsPage.css';
import HeroSectionBox from './custom-comp/HeroSectionBox.jsx';
import MenuSection from './custom-comp/MenuSection.jsx';
import RecommendedClub from './custom-comp/RecommendedClub.jsx';
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import FooterTagSection from './custom-comp/FooterTagSection.js';


export default function VenueClubDetailsPage() {

  const [data, setData] = useState([]);
  const [clubId, setClubId] = useState("");
  const [recomendedClubData, setRecomendedClubData] = useState([]);

  const [partypackages, setPartypackages] = useState([]);
  const [gallery, setGallery] = useState([]);
  const [teasers, setTeasers] = useState([]);
  const [events, setEvents] = useState([]);
  const [menus, setMenus] = useState([]);


  // const { city, area, clubname } = useParams();

  const { clubInfo } = useParams();
  const [clubname, city, area] = clubInfo.split("-").map((str) => str.replace(/_/g, " "));



  const newApi = new FormData();
  newApi.append("city", city);
  newApi.append("area", area);
  newApi.append("club", clubname);

  useEffect(() => {
    axios
      .post("https://partywitty.com/master/APIs/Web/getClubDetails", newApi)
      .then((response) => {
        setData(response.data.data);
        console.log("API Response:", response.data.data);
        setClubId(response.data.data.id);
      })
      .catch((error) => {
        console.error(error);
      });
  }, [clubname]);


  useEffect(() => {
    if (data) {
      setRecomendedClubData(data.recommended_club || []);
      setPartypackages(data.party_packages || []);
      setGallery(data.gallery || []);
      setTeasers(data.teasers || []);
      setEvents(data.events || []);
      setMenus(data.club_menu || []);

    }
  }, [data]);




  return (
    <div className='vcdp-section '>
      <div className='vcdp-container'>
        <HeroSectionBox data={data} />
        <MenuSection partypackages={partypackages} events={events} gallery={gallery} teasers={teasers} menus={menus} />
        <RecommendedClub recomendedClubData={recomendedClubData} />
        <FooterTagSection />
      </div>
    </div>
  )
}
